// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1c-pM","content":"styles_content__29mbf","tableWrap":"styles_tableWrap__u_mtr"};